import { PropsWithChildren, useEffect } from 'react'
import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { AREAS_QUERY_KEY, fetchAreas } from 'api/areas'
import { fetchSetting, SETTINGS_QUERY_KEY } from 'api/settings'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
})

const persister = createAsyncStoragePersister({ storage: window.localStorage })

export const QueryProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    queryClient
      .prefetchQuery({
        queryKey: [AREAS_QUERY_KEY],
        queryFn: fetchAreas,
      })
      .catch(console.error)
    queryClient
      .prefetchQuery({
        queryKey: [SETTINGS_QUERY_KEY],
        queryFn: fetchSetting,
      })
      .catch(console.error)
  }, [])

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      {children}
    </PersistQueryClientProvider>
  )
}
